import React from 'react';

const CreateNavLogo = () => {
  return (
    <div className={"logo-link create"}>
      <a href={'/'}>
        <svg className={'weft-svg create'} id={'weft-mark-nav'} viewBox={'0 0 135.957 65.866'}>
          <path
            className={'w'}
            d={
              'M121.427,0.069h-10.436c-0.184,8.52-0.435,13.764-0.981,21.595h10.338C120.994,12.181,121.012,6.391,121.427,0.069'
            }
          />
          <path
            className={'w'}
            d={
              'M119.014,41.868h-10.288c-1.569,10.522-4.239,13.955-8.929,14.219C89.414,56.673,91.895,0.432,72.098,0.067c-9.079,0.168-13.471,8.724-16.571,21.527h9.55c1.455-6.899,3.325-8.566,7.02-8.737c12.078,0.554,4.661,53.009,26.934,53.009C111.452,65.866,116.673,56.828,119.014,41.868'
            }
          />
          <path
            className={'w'}
            d={
              'M52.388,41.869c-2.173,10.094-4.262,14.442-8.232,14.219C34.768,55.56,33.473,27.325,32.888,0H22.449c1.274,19.484-1.194,65.866,22.467,65.866c11.544,0,15.113-10.348,17.552-23.998H52.388z'
            }
          />
          <polygon
            className={'line-through'}
            points={'0,27.309 0,36.339 18.412,36.339 17.526,27.309 '}
          />
          <polygon
            className={'line-through'}
            points={'40.546,27.308 41.435,36.338 74.827,36.338 73.279,27.308 '}
          />
          <polygon
            className={'line-through'}
            points={'97.077,27.308 98.864,36.341 135.957,36.341 135.957,27.308 '}
          />
        </svg>
      </a>
        <div className={'create-nav-divider'} />
        <a href={'/create'} className={'create-nav-wordmark'}>Create</a>
    </div>
  );
};

export default CreateNavLogo;
